import * as React from 'react';

import { FromToControl } from '../../../common/components/from_to_control';

import * as styles from './index.css';

export interface IAreaProps {
  minArea: number | undefined;
  maxArea: number | undefined;
  onMinAreaChanged(value: number | undefined): void;
  onMaxAreaChanged(value: number | undefined): void;
}

export class Area extends React.Component<IAreaProps> {
  public render() {
    const props = this.props;

    return (
      <FromToControl
        rangeGroupStyle={styles['container']}
        from={{
          value: props.minArea,
          placeholder: 'от',
          onValueChange: value => props.onMinAreaChanged(value),
        }}
        to={{
          value: props.maxArea,
          placeholder: 'до',
          onValueChange: value => props.onMaxAreaChanged(value),
        }}
      />
    );
  }
}
